import { createSelector } from 'reselect';

import { billingApi } from './endpoints';

export const selectDefaultPaymentMethod = createSelector(
  billingApi.endpoints.getPaymentMethods.select(),
  ({ data: paymentMethods }) => paymentMethods?.find((method) => method.defaultFlag),
);
